import React, {Component} from 'react';
import * as func from "../../../utils/functions";
import {MESSAGE, EDIT_MODE, STATUS_NAME} from "../../../wpconfig"
import Loading from "../../etc/loading";
import {getDateYMD} from "../../../utils/functions";

class AuthorityItem extends Component {
	constructor(props) {
		super(props);

		const r = JSON.parse(JSON.stringify(this.props.record));

		this.state = {
			isInit: this.props.record.is_edit,
			isEdit: this.props.record.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record: r,
			field: 'authority',
			name: '전거',
			id: 'authority_id',
			action: 'admin/authority',
			heading: [],
			relation: [],
			parentRecord: {},
			authority_ks: '',
			resources : []
		}

		// this.arrowCopy = this.arrowCopy.bind(this)
		this.relationDelete = this.relationDelete.bind(this)
	}

	getDetail() {
		if (this.state.record[this.state.id]) {
			if (parseInt(this.state.record.term_parent)) {
				func.getData(this.state.action, {'record_id': this.state.record[this.state.id]}).then((response) => {
					this.setState({
						heading: response.record.heading,
					})
					func.getData(this.state.action, {'record_id': this.state.record.term_parent}).then((response) => {
						this.setState({
							parentRecord: response.record,
							relation: response.record.relation,
							isInit: true
						})
					});
				});
			} else {
				func.getData(this.state.action, {'record_id': this.state.record[this.state.id]}).then((response) => {
					this.setState({
						relation: response.record.relation,
						isInit: true
					})
				});
			}

			func.getData('admin/authority_resource', {'record_id': this.state.record[this.state.id]}).then((response) => {
				this.setState({
					resources: response.records
				})
			});
		}
	}

	change = () => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		if (event.target.name === 'position_type') {
			record['position_name'] = this.props.categoryName[event.target.value];
		} else if (event.target.name === 'mou') {
			record['mou'] = event.target.checked ? 'Y' : 'N'
			if (event.target.checked === 'Y') {
			//	논문일괄적용 버튼 활성화
			}
		}

		this.props.onUpdate(this.props.arrIndex, record, true);
	}

	onEditSave = (event, status) => {
		if(event)
			event.preventDefault()
		if(this.props.showSearchPopup)
			return

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}
		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			let record = this.props.record;
			if (!status) {
				record.term_status = "publish"
			}
			if (this.props.record[this.props.pkKey]) {
				record.term_name = record.term_type === 'heading' ? '표제어' : '관계어';
				func.updateData("admin/" + this.state.field + "/" + this.state.record[this.props.pkKey] + "/update", record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({
							record: JSON.parse(JSON.stringify(this.props.record))
						})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			} else {
				record.term_name = record.term_type === 'heading' ? '표제어' : '관계어';
				if (this.authority_term.value === '') {
					this.authority_term.focus();
				} else {
					delete record.is_edit;
					func.updateData("admin/" + this.state.field + "/insert", record).then((response) => {
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							this.setState({'isEdit': isEdit});
							record[this.props.pkKey] = response[this.props.pkKey];
							this.props.onUpdate(this.props.arrIndex, record, true);
							this.props.showMessage('추가 되었습니다.');
						} else {
							this.props.showMessage('저장 실패 : ' + response.message);
						}
					});
				}
			}
		} else {
			this.getDetail();

			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	};

	unEditSave = (event) => {
		let record = this.props.record;
		record.term_status = 'draft'
		this.props.onUpdate(this.props.arrIndex, record, true);

		this.onEditSave(event, record.term_status);
	};

	trashEditSave = (event) => {
		let record = this.props.record;
		record.term_status = 'trash';
		this.props.onUpdate(this.props.arrIndex, record, true);

		this.onEditSave(event, record.term_status);
	};

	onCloseDelete = (event) => {
		event.preventDefault()

		const record = this.props.record;
		if (record[this.props.pkKey]) {
			if (this.state.isEdit) {
				this.props.onUpdate(this.props.arrIndex, this.state.record, true);
				this.setState({'isEdit': EDIT_MODE.SHOW});
			} else {
				if (confirm(record[this.state.id] + ' ' + this.state.name + '를 ' + MESSAGE.DELETE)) {
					let record = this.props.record;
					func.updateData("admin/" + this.state.field + "/" + record[this.state.id] + "/delete", record).then((response) => {
						if (response.code === 'ok') {
							this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.arrIndex)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	relationDelete(index) {
		let record = this.state.relation[index];
		if (confirm(this.state.relation[index].authority_term + '관련어를 ' + MESSAGE.DELETE)) {
			record.term_parent = 0
			func.updateData("admin/" + this.state.field + "/" + record[this.props.pkKey] + "/update", record).then((response) => {
				if (response.code === 'ok') {
					this.props.showMessage('삭제 되었습니다.');
					let relation = this.state.relation;
					relation.splice(index, 1)
					this.setState({
						relation: relation
					})
				} else {
					this.props.showMessage('삭제 실패 : ' + response.message)
				}
			});
		}
	}

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record[this.props.pkKey]) {
			this.props.onUpdate(this.props.arrIndex, this.state.record);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
		this.setState({isInit: false});
	};

	searchPopup = (e) => {
		this.props.setSearchPopup(true, this.props.arrIndex, this.state.authority_ks ? this.state.authority_ks : this.authority_term.value)
	}

	// arrowCopy() {
	// 	this.setState({authority_ks: this.props.record.authority_term});
	// }

	onUpdateResourceByMOU = (e) => {
		let record = this.props.record;
		func.updateData("admin/" + this.state.field + "/" + record[this.props.pkKey] + "/updateResourceByAuthorityMOU", record).then((response) => {
			console.log(response)
			if (response.code === 'ok') {
				this.props.showMessage('논문을 업데이트하였습니다..');
			} else {
				this.props.showMessage('오류 또는 시간지연 : ' + response.message)
			}
		});
	};

	render() {
		const record = this.props.record;

		return (
			<>
				{this.state.isEdit === EDIT_MODE.SHOW ?
					<tr className="list-row">
						<td scope="row" className="mr-0"><input type="checkbox" className="ml-0" /></td>
						<td>{this.props.no}</td>
						<td>{record.authority_id}</td>
						<td>{record.term_type === 'heading' ? '표제어' : '관계어'}</td>
						<td>{record.authority_term}</td>
						<td>{record.position_name}</td>
						<td>{!record.term_status ? <span className="badge badge-item-status bg-danger">확인필요</span>
							: record.term_status === 'publish' ? <span className="badge badge-item-status badge-success">{STATUS_NAME[record.term_status]}</span>
								: record.term_status === 'draft' ? <span className="badge badge-item-status badge-warning">{STATUS_NAME[record.term_status]}</span>
									: record.term_status === 'trash' ? <span className="badge badge-item-status badge-dark">{STATUS_NAME[record.term_status]}</span>
										: record.term_status === 'unpublish' ? <span className="badge badge-item-status badge-secondary">{STATUS_NAME[record.term_status]}</span>
											: ''
						}
						</td>
						<td>{getDateYMD(record.input_date)}</td>
						<td>
							<div className="btn-group">
								<button type="button" className="btn btn-outline-success btn-sm"
								        onClick={this.onEditSave}>{record[this.props.pkKey] ? '편집' : '저장'}</button>
								<button type="button" className="btn btn-outline-danger btn-sm" onClick={this.onCloseDelete}>삭제</button>
							</div>
						</td>
					</tr>
					:
					this.state.isInit ?
						<tr className="edit-row">
							<td colSpan="9" className="colspanchange">
								<div className="row mr-1 ml-1">
									<h5>전거 편집</h5>
								</div>
								<div className="row mr-1 ml-1">
									<div className="col-6">
										<div className="row">
											<div className="col-3">
												<div className="form-group">
													<label htmlFor="term"><strong>ID</strong></label>
													<p>{record.authority_id}</p>
												</div>
											</div>
											<div className="col-9">
												<div className="form-group">
													<label htmlFor="term"><strong>용어</strong></label>
													<div>
														<input
															type="text"
															name="authority_term"
															ref={(ref) => this.authority_term = ref}
															className="form-control-sm large-text"
															value={record.authority_term}
															onChange={this.change} readOnly={record.authority_id}
														/>
													</div>
												</div>
												<div className="form-group">
													<label htmlFor="term"><strong>Display(영문)</strong></label>
													<div>
														<input
															type="text"
															name="authority_name"
															ref={(ref) => this.authority_name = ref}
															className="form-control-sm large-text"
															value={record.authority_name}
															onChange={this.change}
														/>
													</div>
												</div>
												<div className="form-group">
													<label htmlFor="term"><strong>Display(한글)</strong></label>
													<div>
														<input
															type="text"
															name="authority_name2"
															ref={(ref) => this.authority_name2 = ref}
															className="form-control-sm large-text"
															value={record.authority_name2}
															onChange={this.change}
														/>
													</div>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-3">
												<div className="form-group mt-2">
													<div><label><strong>유형</strong></label></div>
													<div>
														<div className="form-check form-check-inline">
															<input className="form-check-input" type="checkbox"
																   name="term_type" id="term_type-heading"
																   checked={record.term_type === 'heading'}
																   onChange={this.change} value="heading"/>
															<label className="form-check-label"
																   htmlFor="term_type-heading">표제어</label>
														</div>
														<div className="form-check form-check-inline">
															<input className="form-check-input" type="checkbox"
																   name="term_type" id="term_type-relation"
																   checked={record.term_type === 'relation'}
																   onChange={this.change} value="relation"/>
															<label className="form-check-label"
																   htmlFor="term_type-relation">관계어</label>
														</div>
													</div>
												</div>
											</div>
											<div className="col-9">
												<div className="form-group mt-2">
													<div><label><strong>포털검색</strong></label></div>
													<div>
														<a href={"https://www.google.com/search?q=" + record.authority_term} target="_blank" className="btn btn-sm btn-outline-dark mr-1">Google</a>
														<a href={"https://search.naver.com/search.naver?query=" + record.authority_term} target="_blank" className="btn btn-sm btn-outline-dark mr-1">NAVER</a>
													</div>
												</div>
											</div>
										</div>
										{record.term_type === 'relation' &&
										<div className="form-group form-row mt-2">
											<div className="col"><label htmlFor="term"><strong>WOS ID</strong></label>
												<input type="text" name="wos_id"
												       ref={(ref) => this.wos_id = ref}
												       className="form-control-sm large-text" defaultValue={record.wos_id}
												       onKeyUp={this.change}/>
											</div>
											<div className="col"><label htmlFor="term"><strong>KCI ID</strong></label>
												<input type="text" name="kci_id"
												       ref={(ref) => this.kci_id = ref}
												       className="form-control-sm large-text" defaultValue={record.kci_id}
												       onKeyUp={this.change}/>
											</div>
											<div className="col"><label htmlFor="term"><strong>SCOPUS ID</strong></label>
												<input type="text" name="scopus_id"
												       ref={(ref) => this.scopus_id = ref}
												       className="form-control-sm large-text" defaultValue={record.scopus_id}
												       onKeyUp={this.change}/>
											</div>
										</div>
										}
										<div className="form-group mt-2">
											<div><label><strong>메모</strong></label></div>
											<div>
											<textarea
												name="memo"
												ref={(ref) => this.memo = ref}
												className="form-control-sm large-text authority-memo" defaultValue={record.memo}
												onKeyUp={this.change}/>
											</div>
										</div>
									</div>
									<div className="col-6">
										{record.term_type === 'heading' ?
											<div className="term-type-heading">
												<div className="form-group">
													<div><label><strong>포지션</strong></label></div>
													<div>
														{this.props.category.map((type, i) => {
															return (
																<div key={type.code_id} className="form-check form-check-inline">
																	<input type="checkbox" id={"position-" + type.code_id} className="term-position"
																		   name="position_type"
																		   value={type.code_id} checked={record.position_type === type.code_id}
																		   onChange={this.change}/>
																	<label htmlFor={"position-" + type.code_id}
																		   className="form-check-label">{type.code_name}</label>
																</div>
															)
														})}
													</div>
												</div>
												<div><strong>MOU 설정</strong></div>
												<div className="form-group form-row mt-2">
													<div className="col">
														<input className="form-check-input" type="checkbox" name="mou" id="mou"
															   checked={record.mou === 'Y'} value="Y" onChange={this.change}/>
														<label className="form-check-label ml-4" htmlFor="term_type-mou">MOU 여부</label>
														<button type="button" className="btn btn-sm btn-outline-primary" onClick={this.onUpdateResourceByMOU}>논문 일괄 업데이트</button>
													</div>
													<div className="col">
														<label htmlFor="term_code"><strong>MOU 대학코드</strong></label>
														<input type="text" name="mou_code"
															   ref={(ref) => this.mou_code = ref}
															   className="form-control-sm large-text" defaultValue={record.mou_code}
															   onKeyUp={this.change}/>
													</div>
													<div className="col">
														<label htmlFor="term_code"><strong>MOU 체결일자</strong></label>
														<input type="text" name="mou_date"
															   ref={(ref) => this.mou_date = ref}
															   className="form-control-sm large-text" defaultValue={record.mou_date}
															   onKeyUp={this.change}/>
													</div>
												</div>
												<div className="form-group form-row mt-2">
													<div className="col">
														<label htmlFor="term"><strong>WOS ID</strong></label>
														<input type="text" name="wos_id"
															   ref={(ref) => this.wos_id = ref}
															   className="form-control-sm large-text" defaultValue={record.wos_id}
															   onKeyUp={this.change}/>
													</div>
													<div className="col">
														<label htmlFor="term"><strong>KCI ID</strong></label>
														<input type="text" name="kci_id"
															   ref={(ref) => this.kci_id = ref}
															   className="form-control-sm large-text" defaultValue={record.kci_id}
															   onKeyUp={this.change}/>
													</div>
													<div className="col">
														<label htmlFor="term"><strong>SCOPUS ID</strong></label>
														<input type="text" name="scopus_id"
															   ref={(ref) => this.scopus_id = ref}
															   className="form-control-sm large-text" defaultValue={record.scopus_id}
															   onKeyUp={this.change}/>
													</div>
												</div>
											</div>
											:
											<div className="term-type-relation">
												<div className="form-group">
													<div><label><strong>표제어 선택</strong></label></div>
													<div className="form-row">
														<div className="col-9">
															<input type="text" className="form-control form-control-sm"
																   value={this.state.authority_ks}
																   readOnly={true}
															/>
														</div>
														<div className="col-3">
															<button type="button" className="btn btn-primary save"
																	onClick={this.searchPopup}>검색
															</button>
														</div>
													</div>
												</div>
												<div className="form-group mt-3">
													<div className="p-2 bg-white border"><h6>표제어 정보</h6>
														<div className="form-group mb-0">
															<div><label><strong>표제어 아이디</strong>
																<span
																	className="pl-2">
																	{this.props.record.set_authority_term ? this.props.record.set_authority_term :
																		(this.state.parentRecord ? this.state.parentRecord.authority_term : '')}</span></label>
															</div>
														</div>
														<div className="form-group form-row mt-2">
															<div className="col"><label htmlFor="term"><strong>WOS ID</strong></label><br/>
																{this.state.parentRecord ? this.state.parentRecord.wos_id : ''}
															</div>
															<div className="col"><label htmlFor="term"><strong>SCOPUS ID</strong></label><br/>
																{this.state.parentRecord ? this.state.parentRecord.scopus_id : ''}
															</div>
															<div className="col"><label htmlFor="term"><strong>KCI ID</strong></label><br/>
																{this.state.parentRecord ? this.state.parentRecord.kci_id : ''}
															</div>
														</div>
													</div>
												</div>
											</div>
										}
										<div className="btn-group mt-3">
											{record[this.props.pkKey] ?
												<button className="btn btn-outline-primary btn-sm insert"
												        onClick={this.onEditSave}>저장</button> :
												<button className="btn btn-outline-primary btn-sm insert"
												        onClick={this.onEditSave}>저장</button>}
											<button type="button" className="btn btn-sm btn-outline-dark"
											        onClick={this.unEditSave}>임시저장
											</button>
											<button type="button" className="btn btn-sm btn-outline-secondary"
											        onClick={this.trashEditSave}>휴지통
											</button>
											<button className="btn btn-outline-dark btn-sm cancel"
											        onClick={this.onCloseDelete}>닫기
											</button>
										</div>
										<div className="row">
											<div className="col-12">
												<div className="form-group mt-3">
													<label htmlFor="term"><strong>용어가 포함된 논문</strong></label>
												</div>
												<div className="p-1 bg-white border">
													{this.state.resources.map((id, i) => {
														return(<a key={i} href={"admin.php?page=resource&record_id=" + id} target="_blank" className="mr-1">{id}</a>)
													})}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mr-1 ml-1 mt-2">
									{!this.state.isInit ? <Loading/> :
										record[this.props.pkKey] &&
										<div className="col-12">
											<div className="form-group">
												<div className="mb-1">
													<label htmlFor=""><strong>관련어</strong></label>
													<span className="btn-success btn-sm ml-2">표제어</span>
													<span className="btn-info btn-sm ml-2">관련어 처리 완료</span>
													<span className="btn-danger btn-sm ml-2">관련어 처리 미완료</span>
												</div>
												<div className="form-row bg-white border p-1 sub-btn-m-1">
													{this.state.heading && this.state.heading.map((item, i) => {
														if (item.term_status === "publish" && item.term_type === 'heading')
															return (<div key={item.authority_id}
															             className="btn btn-success btn-sm"><span/>{item.authority_term}</div>)
														else
															return (<div key={item.authority_id}
															             className="btn btn-danger btn-sm btn-delete"><span/>{item.authority_term}
															</div>);
													})}
													{this.state.relation && this.state.relation.map((item, i) => {
														if (item.term_status === "publish" && item.term_type === 'relation')
															return (<div key={item.authority_id} onClick={() => this.relationDelete(i)}
															             className="btn btn-info btn-sm btn-delete"><span/>{item.authority_term}
															</div>)
														else
															return (<div key={item.authority_id} onClick={() => this.relationDelete(i)}
															             className="btn btn-danger btn-sm btn-delete"><span/>{item.authority_term}
															</div>);
													})}
												</div>
											</div>
											<div className="submit inline-edit-save mt-0">
												<button type="button" className="btn btn-sm btn-outline-primary save alignright">관련어 업데이트</button>
											</div>
										</div>
									}
								</div>
							</td>
						</tr>
						: <tr>
							<td colSpan={6}><Loading/></td>
						</tr>
				}
			</>
		)
	}
}

export default AuthorityItem;